<template>
  <div class="shouhouCenter clearfix">
    <div class="aa">
      <ui-navigation></ui-navigation>
    </div>
    <div class="aboutBox">
      <div class="info">
        <h3 class="mb-4">售后服务条款</h3>
        <hr class="mb-4">
        <p>
          客户购买本网站商品后，在使用过程中如所购买商品出现问题，具体解决方案取决于本售后服务条款的具体规定，客户可以通过本网站链接联系在线售后客服并获取解决方案：
        </p>
        <p class="MsoListParagraph">
          1. 客户购买本网站销售的软件，如自客户收到激活码之日起7日内（自然日，含本数）遇软件激活等质量问题的，客户可以通过本网站向售后客服提交退换货申请，经售后客服审核确认系软件质量问题的，本网站将于确认客户退换货申请之日起：
        </p>
        <p class="MsoListParagraph">
          <span>&nbsp; &nbsp; &nbsp; a)3</span>
          <span>个工作日内完成换货， </span>
        </p>
        <p>
          <span>&nbsp; &nbsp; &nbsp; b)7</span>
          <span>个工作日内完成退货。</span>
        </p>
        <p class="MsoListParagraph">
          2. 根据《中华人民共和国消费者权益保护法》规定，在线下载或者消费者拆封的音像制品、计算机软件等数字化商品，不享受无理由退货。因此，除上述第1条约定之情形外，本网站销售之软件产品一经交付不得要求退换。
        </p>
        <p class="MsoListParagraph">
          3. 客户超出第1条约定的时间限制或未按照本条约定的程序提出的退换货申请，本网站有权不予受理且无需向客户承担任何责任。
        </p>
        <p class="MsoListParagraph">
          4. 对于被退换的软件产品，本网站有权不经客户同意自行处理。
        </p>
        <p class="MsoListParagraph">
          5．客户在本网站购物，如商品出现降价，可在出码后7日内（自然日，含本数）向售后客服提交退差价申请，经售后客服审核确认后，本网站将于确认客户退差价申请之日起7个工作日内完成退款，以下几项不在退差价范围内:
        </p>
        <p class="MsoListParagraph">
          <span>&nbsp; &nbsp; &nbsp; 1</span>
          <span>）无效订单，如已申请取消或已删除的订单等</span>
        </p>
        <p class="MsoListParagraph">
          <span>&nbsp; &nbsp; &nbsp; 2</span>
          <span>）先款订单未支付的</span>
        </p>
        <p class="MsoListParagraph">
          <span>&nbsp; &nbsp; &nbsp; 3</span>
          <span>）商品无货、参加限时优惠活动商品，包括但不限于秒杀、抢购、限时满减、限时限量优惠券等</span>
        </p>
        <p class="MsoListParagraph">
          <span>&nbsp; &nbsp; &nbsp; 4</span>
          <span>）套装商品、商品本身为赠品的商品</span>
        </p>
        <p class="MsoListParagraph">
          <span>&nbsp; &nbsp; &nbsp; 5</span>
          <span>）购买前无赠品，购买后有赠品，商品本身未降价</span>
        </p>
        <p class="MsoListParagraph">
          <span>&nbsp; &nbsp; &nbsp; 6</span>
          <span>）以客户申请或反馈时的价格为准</span>
        </p>
        <p>
          6. 本售后服务条款最终解释权属本网站所有。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import generalMix from '@/util/mix/general';
import Navigation from '@/components/about/Navigation.vue';

export default {
  name: 'shouhouCenter',
  mixins: [generalMix],
  data () {
    return {
    }
  },
  components:{
    'ui-navigation': Navigation
  },
  mounted() {
    $('html').removeClass('scrollHide');
  }
}
</script>

<style scoped lang='less'>
.shouhouCenter{
  display: flex;
  div.aa{
    width: 200px;
    margin-right: 30px;
  }
  div.aboutBox{
    flex: 1;
    background-color: #FFFFFF;
    border-radius: 15px;
    padding: 30px;
    h1{
      font-size: 32px;
      color: #FF7B00;
    }
    ul{
      list-style: disc;
      padding-left: 30px;
    }
  }
}
@media (max-width: 992px) {
  .shouhouCenter{
    flex-direction: column;
    div.aa{
      margin: 0;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/Shouhou.vue